// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchField',
    standalone: false,
})
export class SearchFieldPipe implements PipeTransform {
    transform (collection: any, ...args: (string[] | string)[]): any {
        if (!Array.isArray(collection) || !args.length) {
            return collection;
        }

        return collection.map((member) => {
            const field = args.map((f) => {
                // Simple property access for nested properties (e.g., 'user.name')
                return this.getNestedProperty(member, f);
            }).join(' ');

            member.searchField = field;

            return member;
        });
    }

    private getNestedProperty (obj: any, path: string | string[]): any {
        if (Array.isArray(path)) {
            return path.reduce((current, prop) => current && current[prop], obj) || '';
        }
        return path.split('.').reduce((current, prop) => current && current[prop], obj) || '';
    }
}
